import { LoaderEvent } from '@resn/gozer-loading';
import { noop } from '@resn/gozer-misc';
import { useLoader, useLoaderContext } from '@resn/gozer-vue/loading';

export const useLoaderComplete = (assets = {}, cb = noop) => {
    const loader = useLoader(assets);
    const loaderContext = useLoaderContext();

    loader.on(LoaderEvent.LOAD_COMPLETE, cb);

    if (loader.state === 'complete') {
        cb({ data: loader.data });
    }

    return loader;
};
